import styled from "styled-components";

export const ContentContainer = styled.span`
  & > p:not(:last-child) {
    padding-bottom: 5px;
  }
`;
